module.exports = __webpack_public_path__ + "78de98b331715c466b8bbc8ffefed29e.pdf";